import React from "react";
import { ColumnConfig } from "grommet";
import { IMedicalEmergencyApiResponse } from "../../../../../../../../services/medical-emergency/typings/IMedicalEmergencyApiResponse";

export const MedicalEmergencyColumns: ColumnConfig<IMedicalEmergencyApiResponse>[] =
  [
    {
      property: "id",
      header: "Emergency ID",
      primary: true,
      search: true,
      render: (item) => {
        return <div className="cell-container">{item.id}</div>;
      },
    },
    {
      property: "symptoms",
      header: "Symptoms",
      primary: true,
      render: (item) => {
        return (
          <div className="cell-container">
            {item.symptoms === "" ? "No Symptoms Added" : item.symptoms}
          </div>
        );
      },
    },
    {
      property: "assignedEms",
      header: "Assigned",
      primary: true,
      render: (item) => {
        return (
          <div className="cell-container">
            {item.assignedEms === "" ||
            item.assignedEms === undefined ||
            item.assignedEms === null
              ? "Not Assigned"
              : "Assigned"}
          </div>
        );
      },
    },
    {
      property: "assignedEms",
      header: "Assigned EMS",
      primary: true,
      render: (item) => {
        return (
          <div className="cell-container">
            {item.assignedEms === "" ||
            item.assignedEms === undefined ||
            item.assignedEms === null
              ? "NA"
              : item.assignedEms}
          </div>
        );
      },
    },
  ];
